
import CTNButton from '@ctn/ui/components/ctn-button';

import { type INotaria } from '@/interfaces/model/TramiteNuevo/INotaria.interface';

import NotaryData from '../components/NotaryData';
import SeleccionDeFormato from '../components/SeleccionDeFormato';



type Props = {
	readonly selectedNotary: INotaria;
	readonly setSelectOther: (selectOther: boolean) => void;
};

const NotarioSeleccionado = ({ selectedNotary, setSelectOther }: Props) => (
	<div className="c-pnp-selected-notary">
		<div className='o-splitter [ u-mb-24 ]'>
			<p className='c-pnp-heading-h4'>
				Notario seleccionado
			</p>
			<CTNButton
				mode="secondary"
				variant="ghost"
				label='Seleccionar otro notario'
				onClick={()=> setSelectOther(false)} />
		</div>
		<div className="[ c-pnp-selected-notary__content ] [ u-mt-24 ]">
			<NotaryData data={selectedNotary} />
		</div>
		<SeleccionDeFormato />
	</div>
);

export default NotarioSeleccionado;
